import { computed, onUnmounted } from "vue";

export function useTaskChangeRequestSocket({ socket, taskId, store }) {
    const socketComputed = computed(() => socket?.value || socket);

    let isBound = false;

    function handleUpsert(data) {
        console.log("🔥 [TaskCR] realtime", data);

        const doc = data?.fullDocument || data;
        if (!doc) return;

        if (String(doc.taskId) !== String(taskId)) return;

        store.commit("ChangeRequest/setChangeRequests", {
            data: doc,
            op: "modified",
        });
    }

    function bindEvents(socketRef) {
        if (isBound) return;

        socketRef.on("taskChangeRequestInsert", handleUpsert);
        socketRef.on("taskChangeRequestUpdate", handleUpsert);

        isBound = true;
    }

    function unbindEvents(socketRef) {
        socketRef.off("taskChangeRequestInsert", handleUpsert);
        socketRef.off("taskChangeRequestUpdate", handleUpsert);
        isBound = false;
    }

    async function init() {
        const socketRef = socketComputed.value;

        if (!socketRef?.connected) {
            console.warn("❌ socket chưa connect");
            return false;
        }

        bindEvents(socketRef);

        socketRef.emit("joinTaskChangeRequest", {
            taskId,
            socketId: socketRef.id,
        });

        console.log("✅ joined taskChangeRequest", taskId);

        return true;
    }

    onUnmounted(() => {
        const socketRef = socketComputed.value;
        if (socketRef) {
            unbindEvents(socketRef);
        }
    });

    return {
        init,
    };
}